import React from "react";
import {
  Control,
  Controller,
  FieldValues,
  FormState,
  UseFormRegister,
  UseFormSetValue,
  useWatch,
} from "react-hook-form";
import "react-phone-input-2/lib/style.css";
import { Input } from "../../../../shared/native/input.styles";
import AddFileButton from "../../../../shared/addFileButton/AddFileButton";
import Modal from "../../../../shared/modal/Modal";
import PhotoRequirementsModal from "./photoRequirementsModal/PhotoRequirementsModal";
import { FormContainer } from "../../../../shared/form/form.styles";
import { AddFileContainer, FieldData } from "../../../../shared/form/fieldData.styles";
import {
  FieldError,
  FieldInfo,
  FieldLink,
  FieldName,
} from "../../../../shared/form/fieldInfo.styles";
import ProfileForm from "../../interfaces/ProfileForm";
import emailRegexp from "../../../../../core/regexp/emailRegexp";
import { useAppSelector } from "../../../../../core/hooks/redux";
import PhoneInput from "../../../../shared/native/phoneInput.styles";
import matchesMask from "../../../../../core/utils/matchesMask";

const ContactsDataForm: React.FC<{
  register: UseFormRegister<FieldValues>;
  formState: FormState<FieldValues>;
  control: Control;
  setValue: UseFormSetValue<ProfileForm>;
}> = ({ register, control, formState: { errors }, setValue }) => {
  const { accountState } = useAppSelector((state) => state.coreState);
  const emailWatch = useWatch({ control, name: "email" });
  const phoneWatch = useWatch({ control, name: "phone" });
  const [showPhotoRequirementsModal, setShowPhotoRequirementsModal] = React.useState(false);
  const [isValidPhoneNumber, setIsValidPhoneNumber] = React.useState(!!phoneWatch.length);

  React.useEffect(() => {
    if (accountState.user?.email && !emailWatch) {
      setValue("email", accountState.user.email);
    }
  }, [accountState]);

  return (
    <>
      <FormContainer>
        <FieldInfo>
          <FieldName>Email</FieldName>
          {errors.email && <FieldError>{errors.email?.message as string}</FieldError>}
        </FieldInfo>
        <FieldData>
          <Input
            className="defaultInput"
            placeholder="Начните вводить"
            hasErrors={!!errors.email}
            {...register("email", {
              required: "Обязательное поле",
              pattern: {
                value: emailRegexp,
                message: "Неверный формат",
              },
            })}
          />
        </FieldData>
        <FieldInfo>
          <FieldName>Телефон</FieldName>
          {errors.phone && <FieldError>{errors.phone?.message as string}</FieldError>}
        </FieldInfo>
        <FieldData>
          <Controller
            name="phone"
            control={control}
            rules={{
              required: "Обязательное поле",
              validate: () => isValidPhoneNumber,
            }}
            render={({ field: { value, onChange } }): React.ReactElement => (
              <PhoneInput
                containerClass="defaultSelect"
                value={value}
                onChange={(phoneValue, country, event, formattedValue): void => {
                  if ("format" in country) {
                    setIsValidPhoneNumber(matchesMask(formattedValue, country.format));
                  }
                  onChange(formattedValue);
                }}
                hasErrors={!!errors.phone}
              />
            )}
          />
        </FieldData>
        <FieldInfo>
          <FieldName>Ваше фото</FieldName>
          {errors.photo && <FieldError>{errors.photo?.message as string}</FieldError>}
          <FieldLink type="button" onClick={(): void => setShowPhotoRequirementsModal(true)}>
            Требования к фото
          </FieldLink>
        </FieldInfo>
        <FieldData>
          <AddFileContainer>
            <AddFileButton
              accept={"image/*"}
              name="photo"
              control={control}
              options={{ required: "Обязательное поле" }}
              setValue={setValue}
            >
              Прикрепить
            </AddFileButton>
          </AddFileContainer>
        </FieldData>
      </FormContainer>
      {showPhotoRequirementsModal && (
        <Modal closeModal={(): void => setShowPhotoRequirementsModal(false)}>
          <PhotoRequirementsModal />
        </Modal>
      )}
    </>
  );
};

export default ContactsDataForm;
